import React from "react";
import { AdditionalResultsSection, LabsSection } from "./face_sheet_workspace/sections";
import type { FaceSheetWorkspaceProps } from "./face_sheet_workspace/types";

export default function FaceSheetValues({ payload = {}, paths, openLinksInWindow = false }: FaceSheetWorkspaceProps) {
  const labs = payload.labs || [];
  const operationSummary = payload.operation_summary;
  const additionalResults = payload.additional_results || {};

  return (
    <div className="space-y-4">
      <LabsSection
        labs={labs}
        operationSummary={operationSummary}
        compareDocumentTemplate={paths.compareDocumentTemplate}
        documentTemplate={paths.documentTemplate}
        openLinksInWindow={openLinksInWindow}
        editable={false}
        onEdit={() => {}}
      />
      <AdditionalResultsSection
        additionalResults={additionalResults}
        compareDocumentTemplate={paths.compareDocumentTemplate}
        documentTemplate={paths.documentTemplate}
        editable={false}
        onEdit={() => {}}
      />
    </div>
  );
}
